/**
 * content/legal/labels.js — Petite map de labels UI scoped aux pages légales.
 *
 * D-LEGAL-EN-5 : PAS d'i18n global. Ces quelques chaînes d'interface propres au
 * shell légal (bouton retour, fallback de chargement) sont sélectionnées par
 * langue via cette map locale, alimentée UNIQUEMENT par la langue de l'URL
 * (/legal/* ⇒ fr, /en/legal/* ⇒ en). Repli sur `fr` si la langue est inconnue.
 */
export const legalLabels = {
  fr: { back: 'Retour', loading: 'Chargement…' },
  en: { back: 'Back',   loading: 'Loading…' },
};

export default legalLabels;
